import { db } from '../firebase';
import { collection, getDocs, query, where, doc, getDoc, writeBatch } from 'firebase/firestore';

// One-time migration: normalize certificate 'category' to the course's actual category,
// remove 'General' defaults, and ensure at most one certificate per (userId, courseId).
// Usage: call runCertificateCategoryMigration() from an admin-only screen or console.
export async function runCertificateCategoryMigration() {
  const certificatesRef = collection(db, 'certificates');
  const snapshot = await getDocs(certificatesRef);

  // Group certificates by userId+courseId to dedupe
  const byKey = new Map();
  snapshot.docs.forEach(d => {
    const data = d.data();
    const key = `${data.userId}__${data.courseId}`;
    if (!byKey.has(key)) byKey.set(key, []);
    byKey.get(key).push({ id: d.id, data });
  });

  const batch = writeBatch(db);
  let updates = 0;
  let deletions = 0;

  for (const [key, certs] of byKey.entries()) {
    // Sort by generatedAt asc, fallback to completedAt
    certs.sort((a, b) => {
      const aTs = a.data.generatedAt || a.data.completedAt || '';
      const bTs = b.data.generatedAt || b.data.completedAt || '';
      return new Date(aTs) - new Date(bTs);
    });

    // Keep the oldest, delete others
    const [keep, ...dups] = certs;
    for (const dup of dups) {
      batch.delete(doc(db, 'certificates', dup.id));
      deletions += 1;
    }

    // Normalize category on the kept doc
    if (keep) {
      const { courseId } = keep.data;
      let courseCategory = '';
      try {
        const courseSnap = await getDoc(doc(db, 'courses', courseId));
        if (courseSnap.exists()) {
          courseCategory = courseSnap.data().category || '';
        }
      } catch {}

      const currentCategory = keep.data.category;
      const needsFix = currentCategory === 'General' || currentCategory == null || currentCategory === '' || keep.data.generatedAt == null;
      if (needsFix) {
        const updatePayload = {
          ...keep.data,
          generatedAt: keep.data.generatedAt || keep.data.completedAt || new Date().toISOString(),
        };
        if (courseCategory) {
          updatePayload.category = courseCategory;
        } else {
          // Ensure we don't write undefined; also remove invalid 'General'
          if (updatePayload.category === 'General' || updatePayload.category == null || updatePayload.category === '') {
            delete updatePayload.category;
          }
        }
        batch.set(doc(db, 'certificates', keep.id), updatePayload, { merge: true });
        updates += 1;
      }
    }
  }

  if (updates > 0 || deletions > 0) {
    await batch.commit();
  }

  return { updated: updates, deleted: deletions };
}


